/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Ai Interaction Record Item
 */
export type AiInteractionRecordItem = {
    /**
     * Record Unique ID
     */
    id?: number;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    created?: number;
    /**
     * userId
     */
    userId?: number;
    /**
     * logAIEventId
     */
    logAIEventId?: number;
    /**
     * ai Action
     */
    aiAction?: AiInteractionRecordItem.aiAction;
    /**
     * payload
     */
    payload?: string;
    /**
     * API Response Version
     */
    _ver?: number;
}

export namespace AiInteractionRecordItem {

    /**
     * ai Action
     */
    export enum aiAction {
        USED = 'used',
        RETRIED = 'retried',
        FLAGGED = 'flagged',
        RATED = 'rated',
    }


}
